import moment from "moment";
import calendarCardProduct from "./templates/calendarCardProduct";
import calendarCardInternalArea from "./templates/calendarCardInternalArea";
import calendarCardInternalAreaAccordion from "./templates/calendarCardInternalAreaAccordion";

const emtpyCalendarCardOptions = {
  hasMultipleCourses: false,
  cardId: null,
  arrow: null,

  title: null,
  border: null,

  roomNumbers: [],
  useOnlineTitle: null,
  live: null,

  courseDesc: null,
  courseNumber: null,
  subjects: [],
  link: null,
}

export function addDateEventListeners(
  calendarDomElement,
  courseInfoDomElementId,
  courses,
  isOnProductPage = false
) {
  const desktopBreakpoint = 992;

  const courseInfoDomElement = document.getElementById(courseInfoDomElementId);
  const dayElements = [
    ...calendarDomElement.querySelectorAll(
      ".fc-daygrid-day-top[class*=event_color]"
    ),
  ];

  dayElements.forEach((dayElement) => {
    const dateString = dayElement.parentNode.parentNode.dataset.date;
    const date = moment(dateString);

    dayElement.addEventListener("click", () => {
      if (window.innerWidth < desktopBreakpoint) {
        processCourseInfo(dayElement, date);
      }
    });

    dayElement.addEventListener("mouseenter", () => {
      processCourseInfo(dayElement, date);
    });

    dayElement.addEventListener("mouseleave", (e) => {
      if (window.innerWidth >= desktopBreakpoint) {
        if (leftBothElements(e, dayElement)) {
          hideCourseInfo();
        }
      }
    });

    courseInfoDomElement.addEventListener("mouseleave", (e) => {
      if (window.innerWidth >= desktopBreakpoint) {
        if (leftBothElements(e, dayElement)) {
          hideCourseInfo();
        }
      }
    });

    document.addEventListener("click", function (e) {
      let shouldClose = true;
      const domParentSteps = 10;

      if (e.target.classList.contains("fc-daygrid-day-number")) {
        shouldClose = false;
      } else {
        let currentElement = e.target;
        [...Array(domParentSteps).keys()].some(count => {
          if ([...currentElement.classList].includes(courseInfoDomElementId)) {
            shouldClose = false;
            return true;
          }
          if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
          } else {
            return true;
          }
        })
      }

      if (shouldClose) {
        hideCourseInfo();
      }
    });
  });

  const processCourseInfo = (dayElement, date) => {
    let displayCourses = [];

    for (let i = 0; i < courses.length; i++) {
      let currentCourse = courses[i];
      if (date.isSame(moment(currentCourse.veranstvonz), "day")) {

        const currentDisplayCourseIndex = displayCourses.findIndex(
          displayCourse => displayCourse.kurs.kursnr == currentCourse.kurs.kursnr
        );
        const courseAlreadyInDisplayCourses = currentDisplayCourseIndex !== -1;

        if (courseAlreadyInDisplayCourses) {
          const courseDoesentHaveSameEvent = displayCourses[currentDisplayCourseIndex].times.findIndex(
            displayCourse => displayCourse.terminnr == currentCourse.terminnr
          ) === -1;
          if (courseDoesentHaveSameEvent) {
            displayCourses[currentDisplayCourseIndex].times.push({
              terminnr: currentCourse.terminnr,
              from: currentCourse.veranstvonz,
              to: currentCourse.veranstbisz
            });
            displayCourses[currentDisplayCourseIndex].subjects.push(currentCourse.unterrichtsfach.fachbez);
            if (currentCourse.raum.raumnr !== "WEB") {
              if (!displayCourses?.[currentDisplayCourseIndex]?.roomNumbers) {
                displayCourses[currentDisplayCourseIndex].roomNumbers = [];
              }
              displayCourses[currentDisplayCourseIndex].roomNumbers.push(currentCourse.raum.raumnr);
            }
          }
        } else {
          currentCourse.border = "event_color--" + currentCourse.location;

          if (currentCourse.raum.raumnr !== "WEB") {
            currentCourse.useOnlineTitle = false;
            currentCourse.roomNumbers = [];
            currentCourse.roomNumbers.push(currentCourse.raum.raumnr);
            if (currentCourse.location.includes("livestream")) {
              currentCourse.live = true;
            }
          } else {
            currentCourse.useOnlineTitle = true;
          }

          currentCourse.courseDesc = currentCourse.kurs.kursbez;
          currentCourse.courseNumber = currentCourse.kurs.kursnr;
          currentCourse.subjects = [];
          currentCourse.subjects.push(currentCourse.unterrichtsfach.fachbez);
          currentCourse.link = "/meine-kurse/?course=" + currentCourse.kurs.kursnr;

          currentCourse.times = [];
          currentCourse.times.push({
            terminnr: currentCourse.terminnr,
            from: currentCourse.veranstvonz,
            to: currentCourse.veranstbisz
          });
          displayCourses.push(currentCourse);
        }
      }
    }

    hideCourseInfo();

    if (displayCourses.length > 0) {
      const hasMultipleCourses =  displayCourses.length > 1;
      let htmlString = '';
      displayCourses.forEach((displayCourse, displayCourseIndex) => {
        const card = emtpyCalendarCardOptions;
        card.cardClass = courseInfoDomElementId;
        const cardPosition = getCardPosition(dayElement);
        card.arrow = cardPosition.arrow;
        card.title = getCourseTitleFromTimes(displayCourse.times);
        card.border = displayCourse.border;

        card.tag = displayCourse.tag;

        card.roomNumbers = [...new Set(displayCourse.roomNumbers)];
        card.useOnlineTitle = displayCourse.useOnlineTitle;
        card.live = displayCourse.live;
        card.moodleLink = displayCourse?.kurs?.moodleLink;

        card.courseDesc = displayCourse.courseDesc;
        card.courseNumber = displayCourse.courseNumber;
        card.subjects = [...new Set(displayCourse.subjects)];
        card.link = displayCourse.link;
        card.index = displayCourseIndex;
        card.hasMultipleTimes = displayCourse.times.length > 1;

        htmlString += isOnProductPage
          ? calendarCardProduct(card)
          : (hasMultipleCourses
              ? calendarCardInternalAreaAccordion(card)
              : calendarCardInternalArea(card)
            )
        ;
        setCardPosition(cardPosition);
      })
      setCourseInfo(htmlString);
      showCourseInfo();
    }
  };

  const getCardPosition = (dayElement) => {
    let cell = dayElement.parentElement.parentElement.parentElement;

    const dayBoundingClientRect = dayElement.getBoundingClientRect();
    const cellBoundingClientRect = cell.getBoundingClientRect();

    const width = cell.offsetWidth;
    const bottom =
      document.body.scrollHeight - window.scrollY -
      dayBoundingClientRect.top + 94;
    const left =
      cellBoundingClientRect.left +
      cell.offsetWidth / 2 +
      document.documentElement.scrollLeft -
      cell.offsetWidth / 2;
    const arrow =
      dayBoundingClientRect.left -
      cellBoundingClientRect.left +
      dayElement.offsetWidth / 2;

    return {
      width: width,
      bottom: bottom,
      left: left,
      arrow: arrow,
    };
  };

  const setCardPosition = (position) => {
    courseInfoDomElement.style.width = position.width + "px";
    courseInfoDomElement.style.bottom = position.bottom + "px";
    courseInfoDomElement.style.left = position.left + "px";
  }

  const setCourseInfo = (innerHTML) => {
    courseInfoDomElement.innerHTML = innerHTML;
  };

  const showCourseInfo = () => {
    courseInfoDomElement.classList.remove('d-none');
  };

  const hideCourseInfo = () => {
    courseInfoDomElement.classList.add('d-none');
  };


  const getCourseTitleFromTimes = (times) => {
    let result = "";
    moment.locale("de");

    if (times) {

      times.sort((a, b) => a.from.localeCompare(b.from));
      let resultTimes = times;

      resultTimes.forEach((timeObject, index) => {
        if (index > 0) {
          const lastTimeObject = resultTimes[index - 1];
          const currentTimeObject = timeObject;
          if (moment(lastTimeObject.to).isSame(currentTimeObject.from)) {
            lastTimeObject.to = currentTimeObject.to;
            resultTimes.splice(index, 1);
          }
        }
      });

      if (resultTimes.length === 1) {
        const from = moment(resultTimes[0].from);
        const to = moment(resultTimes[0].to);
        result = from.format("dd. DD.MM.YYYY") + ", " + from.format("HH:mm") + " bis " + to.format("HH:mm");
      } else {
        resultTimes.forEach((timeObject, index) => {
          const from = moment(timeObject.from);
          const to = moment(timeObject.to);
          if (index === 0) {
            result += from.format("dd. DD.MM.YYYY") + "<br>";
          }
          result += from.format("HH:mm") + " bis " + to.format("HH:mm");
          if (index < times.length - 1) {
            result += " & ";
          }
        });
      }
    }
    return result;
  };

  const leftBothElements = (event, day) => {
    const id = event?.relatedTarget?.id;
    return id != courseInfoDomElementId && event.relatedTarget != day;
  };
}
